<template>
  <!-- new layout -->
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-5 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card">
                <div class="card-body min-vh-60 d-block text-center">
                  <div class="text-center">
                    <div class="row justify-content-center mt-0">
                      <div class="col-12 mb-3 py-5 pb-2">
                        <template v-if="isLoading">
                          <div class="h1 mb-3">
                            <Skeleton width="80px" height="30px" class="mx-auto"
                              style="margin-bottom: 1rem; border-radius: 20px" />
                          </div>
                          <div class="h1 mb-3">
                            <Skeleton width="200px" height="30px" class="mx-auto"
                              style="margin-bottom: 1rem; border-radius: 20px" />
                          </div>
                          <div class="h5 mb-3 w-80 m-auto">
                            <Skeleton width="100%" height="30px" style="border-radius: 50px" />
                          </div>
                        </template>
                        <template v-else>
                          <div class="h1 mb-3">
                            <i class="fas"
                              :class="isInvitationApproved ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'">
                            </i>
                            <h3 class="text-center">
                              {{ isInvitationApproved ? 'Success' : 'Error' }}
                            </h3>
                          </div>
                          <div class="h6 px-lg-4 px-md-3 px-4" :class="isInvitationApproved ? 'mb-3' : 'mb-3'">
                            {{ message }}
                            <router-link v-if="isInvitationApproved" to="/login">
                              <button class="btn btn-primary d-block mt-5 mb-0 mx-auto"><span
                                  class="me-2">Login</span><i class="fa fa-sign-in" aria-hidden="true"></i></button>
                            </router-link>
                          </div>
                        </template>
                      </div>

                      <div class="text-center mb-5">
                        <img width="130" src="@/assets/img/modal_logo_dark.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
              <div
                class="position-relative h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden login-bg-container-success"
                :class="!isInvitationApproved ? 'login-bg-container-error' : ''">
                <span class="mask bg-gradient-success opacity-0 bg-gradient-success-login"></span>

                <h4 class="mt-5 text-white font-weight-bolder position-relative">"Knowledge grows exponentially. The
                  more we know, the greater our ability to learn, and the faster we expand our knowledge base"</h4>
                <p class="text-white position-relative">~Dan Brown</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import axios from 'axios';
export default {
  name: 'Joinlink',
  data() {
    return {
      isLoading: false,
      isInvitationApproved: false,
      message: '',
    };
  },
  methods: {
    async join() {
      this.isLoading = true;
      let url = `https://join.modalsupport.com/invitation/approve`;
      if (this.$route?.query?.token) {
        url = `${url}?token=${this.$route?.query?.token}`;
      }
      axios
        .get(url)
        .then(response => {
          this.$store.dispatch('printLog', { text: 'successfully joined the library ', log: response, type: 'success' });
          this.message = response.data ?? 'Successfully added to the library. Please go to your library login page and reset your password to login!';
          this.isInvitationApproved = true;
        })
        .catch(error => {
          this.$store.dispatch('printLog', { text: 'error while joining the library ', log: error, type: 'error' });
          this.message = error.response.data ?? 'This invitation is either expired or already used, Please contact your administrator to get a new invitation.';
          this.isInvitationApproved = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    this.join();
  },
};
</script>

<style scoped>
:root {
  --mi-chat-primary-color: rgb(4, 0, 255, 1);
}

/* start rating css */
:root {
  --start_rating_bg: #e3e4e8;
  --start_rating_fg: #17181c;
  --start_rating_primary: #255ff4;
  --start_rating_yellow: #f4a825;
  --start_rating_yellow_darkborder: #fca40c;
  --start_rating_yellow-t: rgba(244, 168, 37, 0);
  --start_rating_bezier: cubic-bezier(0.42, 0, 0.58, 1);
  --start_rating_trans-dur: 0.3s;
  --start_rating_fs: 1.35rem;
}

#start-rating.start-rating-wrap .rating {
  margin: auto;
}

#start-rating.start-rating-wrap .rating__display {
  font-size: 0.95rem !important;
  font-weight: 400;
  min-height: 1.25em;
  position: absolute;
  top: 90%;
  width: 100%;
  text-align: center;
  color: #666;
}

#start-rating.start-rating-wrap .rating__stars {
  display: flex;
  padding-bottom: 0.375em;
  position: relative;
}

#start-rating.start-rating-wrap .rating__star {
  display: block;
  overflow: visible;
  pointer-events: none;
  width: 2em;
  height: 2em;
}

#start-rating.start-rating-wrap .rating__star-ring,
.rating__star-fill,
.rating__star-line,
.rating__star-stroke {
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: forwards;
}

#start-rating.start-rating-wrap .rating__star-ring,
.rating__star-fill,
.rating__star-line {
  stroke: var(--start_rating_yellow);
}

#start-rating.start-rating-wrap .rating__star-fill {
  fill: var(--start_rating_yellow);
  transform: scale(0);
  transition: fill var(--start_rating_trans-dur) var(--start_rating_bezier), transform var(--start_rating_trans-dur) var(--start_rating_bezier);
}

#start-rating.start-rating-wrap .rating__star-line {
  stroke-dasharray: 12 13;
  stroke-dashoffset: -13;
}

#start-rating.start-rating-wrap .rating__star-stroke {
  stroke: #c7cad1;
  transition: stroke var(--start_rating_trans-dur);
}

#start-rating.start-rating-wrap .rating__label {
  cursor: pointer;
  padding: 0.3em;
  margin: 0;
  font-size: 1.65rem;
}

#start-rating.start-rating-wrap .rating__label--delay1 .rating__star-ring,
#start-rating.start-rating-wrap .rating__label--delay1 .rating__star-fill,
#start-rating.start-rating-wrap .rating__label--delay1 .rating__star-line,
#start-rating.start-rating-wrap .rating__label--delay1 .rating__star-stroke {
  animation-delay: 0.05s;
}

#start-rating.start-rating-wrap .rating__label--delay2 .rating__star-ring,
#start-rating.start-rating-wrap .rating__label--delay2 .rating__star-fill,
#start-rating.start-rating-wrap .rating__label--delay2 .rating__star-line,
#start-rating.start-rating-wrap .rating__label--delay2 .rating__star-stroke {
  animation-delay: 0.1s;
}

#start-rating.start-rating-wrap .rating__label--delay3 .rating__star-ring,
#start-rating.start-rating-wrap .rating__label--delay3 .rating__star-fill,
#start-rating.start-rating-wrap .rating__label--delay3 .rating__star-line,
#start-rating.start-rating-wrap .rating__label--delay3 .rating__star-stroke {
  animation-delay: 0.15s;
}

#start-rating.start-rating-wrap .rating__label--delay4 .rating__star-ring,
#start-rating.start-rating-wrap .rating__label--delay4 .rating__star-fill,
#start-rating.start-rating-wrap .rating__label--delay4 .rating__star-line,
#start-rating.start-rating-wrap .rating__label--delay4 .rating__star-stroke {
  animation-delay: 0.2s;
}

#start-rating.start-rating-wrap .rating__input {
  position: absolute;
  -webkit-appearance: none;
  appearance: none;
}

#start-rating.start-rating-wrap .rating__input:hover ~ [data-rating]:not([hidden]) {
  display: none;
}

#start-rating.start-rating-wrap .rating__input-1:hover ~ [data-rating='1'][hidden],
#start-rating.start-rating-wrap .rating__input-2:hover ~ [data-rating='2'][hidden],
#start-rating.start-rating-wrap .rating__input-3:hover ~ [data-rating='3'][hidden],
#start-rating.start-rating-wrap .rating__input-4:hover ~ [data-rating='4'][hidden],
#start-rating.start-rating-wrap .rating__input-5:hover ~ [data-rating='5'][hidden],
#start-rating.start-rating-wrap .rating__input:checked:hover ~ [data-rating]:not([hidden]) {
  display: block;
}

#start-rating.start-rating-wrap .rating__input-1:hover ~ .rating__label:first-of-type .rating__star-stroke,
#start-rating.start-rating-wrap .rating__input-2:hover ~ .rating__label:nth-of-type(-n + 2) .rating__star-stroke,
#start-rating.start-rating-wrap .rating__input-3:hover ~ .rating__label:nth-of-type(-n + 3) .rating__star-stroke,
#start-rating.start-rating-wrap .rating__input-4:hover ~ .rating__label:nth-of-type(-n + 4) .rating__star-stroke,
#start-rating.start-rating-wrap .rating__input-5:hover ~ .rating__label:nth-of-type(-n + 5) .rating__star-stroke {
  stroke: var(--start_rating_yellow);
  transform: scale(1);
}

#start-rating.start-rating-wrap .rating__input-1:checked ~ .rating__label:first-of-type .rating__star-ring,
#start-rating.start-rating-wrap .rating__input-2:checked ~ .rating__label:nth-of-type(-n + 2) .rating__star-ring,
#start-rating.start-rating-wrap .rating__input-3:checked ~ .rating__label:nth-of-type(-n + 3) .rating__star-ring,
#start-rating.start-rating-wrap .rating__input-4:checked ~ .rating__label:nth-of-type(-n + 4) .rating__star-ring,
#start-rating.start-rating-wrap .rating__input-5:checked ~ .rating__label:nth-of-type(-n + 5) .rating__star-ring {
  animation-name: starRing;
}

#start-rating.start-rating-wrap .rating__input-1:checked ~ .rating__label:first-of-type .rating__star-stroke,
#start-rating.start-rating-wrap .rating__input-2:checked ~ .rating__label:nth-of-type(-n + 2) .rating__star-stroke,
#start-rating.start-rating-wrap .rating__input-3:checked ~ .rating__label:nth-of-type(-n + 3) .rating__star-stroke,
#start-rating.start-rating-wrap .rating__input-4:checked ~ .rating__label:nth-of-type(-n + 4) .rating__star-stroke,
#start-rating.start-rating-wrap .rating__input-5:checked ~ .rating__label:nth-of-type(-n + 5) .rating__star-stroke {
  animation-name: starStroke;
}

#start-rating.start-rating-wrap .rating__input-1:checked ~ .rating__label:first-of-type .rating__star-line,
#start-rating.start-rating-wrap .rating__input-2:checked ~ .rating__label:nth-of-type(-n + 2) .rating__star-line,
#start-rating.start-rating-wrap .rating__input-3:checked ~ .rating__label:nth-of-type(-n + 3) .rating__star-line,
#start-rating.start-rating-wrap .rating__input-4:checked ~ .rating__label:nth-of-type(-n + 4) .rating__star-line,
#start-rating.start-rating-wrap .rating__input-5:checked ~ .rating__label:nth-of-type(-n + 5) .rating__star-line {
  animation-name: starLine;
}

#start-rating.start-rating-wrap .rating__input-1:checked ~ .rating__label:first-of-type .rating__star-fill,
#start-rating.start-rating-wrap .rating__input-2:checked ~ .rating__label:nth-of-type(-n + 2) .rating__star-fill,
#start-rating.start-rating-wrap .rating__input-3:checked ~ .rating__label:nth-of-type(-n + 3) .rating__star-fill,
#start-rating.start-rating-wrap .rating__input-4:checked ~ .rating__label:nth-of-type(-n + 4) .rating__star-fill,
#start-rating.start-rating-wrap .rating__input-5:checked ~ .rating__label:nth-of-type(-n + 5) .rating__star-fill {
  animation-name: starFill;
}

#start-rating.start-rating-wrap .rating__input-1:not(:checked):hover ~ .rating__label:first-of-type .rating__star-fill,
#start-rating.start-rating-wrap .rating__input-2:not(:checked):hover ~ .rating__label:nth-of-type(2) .rating__star-fill,
#start-rating.start-rating-wrap .rating__input-3:not(:checked):hover ~ .rating__label:nth-of-type(3) .rating__star-fill,
#start-rating.start-rating-wrap .rating__input-4:not(:checked):hover ~ .rating__label:nth-of-type(4) .rating__star-fill,
#start-rating.start-rating-wrap .rating__input-5:not(:checked):hover ~ .rating__label:nth-of-type(5) .rating__star-fill {
  fill: var(--start_rating_yellow-t);
}

#start-rating.start-rating-wrap .rating__sr {
  clip: rect(1px, 1px, 1px, 1px);
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

@media (prefers-color-scheme: dark) {
  :root {
    --start_rating_bg: #17181c;
    --start_rating_fg: #e3e4e8;
  }

  #start-rating.start-rating-wrap .rating {
    margin: auto;
  }

  #start-rating.start-rating-wrap .rating__star-stroke {
    stroke: #454954;
  }
}

@keyframes starRing {
  from,
  20% {
    animation-timing-function: ease-in;
    opacity: 1;
    r: 8px;
    stroke-width: 16px;
    transform: scale(0);
  }

  35% {
    animation-timing-function: ease-out;
    opacity: 0.5;
    r: 8px;
    stroke-width: 16px;
    transform: scale(1);
  }

  50%,
  to {
    opacity: 0;
    r: 16px;
    stroke-width: 0;
    transform: scale(1);
  }
}

@keyframes starFill {
  from,
  40% {
    animation-timing-function: ease-out;
    transform: scale(0);
  }

  60% {
    animation-timing-function: ease-in-out;
    transform: scale(1.2);
  }

  80% {
    transform: scale(0.9);
  }

  to {
    transform: scale(1);
  }
}

@keyframes starStroke {
  from {
    transform: scale(1);
  }

  20%,
  to {
    transform: scale(0);
  }
}

@keyframes starLine {
  from,
  40% {
    animation-timing-function: ease-out;
    stroke-dasharray: 1 23;
    stroke-dashoffset: 1;
  }

  60%,
  to {
    stroke-dasharray: 12 13;
    stroke-dashoffset: -13;
  }
}

#start-rating {
  caret-color: transparent !important;
}

#start-rating.start-rating-wrap .rating__label[for='rating-1']:hover ~ .rating__display[data-rating='1'],
#start-rating.start-rating-wrap .rating__label[for='rating-2']:hover ~ .rating__display[data-rating='2'],
#start-rating.start-rating-wrap .rating__label[for='rating-3']:hover ~ .rating__display[data-rating='3'],
#start-rating.start-rating-wrap .rating__label[for='rating-4']:hover ~ .rating__display[data-rating='4'],
#start-rating.start-rating-wrap .rating__label[for='rating-5']:hover ~ .rating__display[data-rating='5'] {
  display: block !important;
}

/* end of star rating */
#rating-1-10 textarea.min-h-150 {
  min-height: 130px;
}

#rating-1-10 .form-floating > .form-control {
  padding: 1.5rem 1.2rem !important;
  padding-top: 2.5rem !important;
}
#rating-1-10 .form-floating > .form-control label {
  padding-top: 1.5rem !important;
}

#rating-1-10 .form-check-input {
  display: none;
}

#rating-1-10 .form-check-label {
  width: 42px;
  height: 42px;
  background-color: #e5e5e5;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

#rating-1-10 .form-check-input:checked + .form-check-label.best-rate,
#rating-1-10 .form-check-input:checked + .form-check-label {
  background-color: #4bba87 !important;
  color: white !important;
  transform: scale(1.1);
  caret-color: transparent !important;
}

#rating-1-10 .form-check-input:checked + .form-check-label.good-rate {
  background-color: #99d1a5 !important;
}
#rating-1-10 .form-check-input:checked + .form-check-label.normal-rate {
  background-color: #e7c503 !important;
}
#rating-1-10 .form-check-input:checked + .form-check-label.bad-rate {
  background-color: #dd2d01 !important;
}

#rating-1-10 .form-check-label:hover {
  background-color: #d1d1d1 !important;
  /* transform: scale(1.1); */
}

#rating-1-10 .small-text {
  font-size: 0.8rem;
  font-weight: bold;
  color: #333;
}

#rating-1-10 .form-check {
  padding-left: unset !important;
}
#rating-1-10 .form-check {
  margin-right: 5px;
}

@media (min-width: 992px) {
  #rating-1-10 .form-check {
    outline: none;
  }
}

@media (max-width: 991px) {
  #rating-1-10 .form-check {
    outline: none;
  }
}
#rating-1-10 .card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow-wrap: break-word;
}
#rating-1-10 .card:not(.border-0) {
  border: 1px solid #e9e9e9;
  border-radius: 10px;
  max-width: 800px;
  margin: auto;
  margin-top: 20px;
  box-shadow: 0px 0px 20px 0px #e9e9e9;
}
#rating-1-10 .card:not(.border-0):hover {
  border: 1px solid #e2e2e2;
  box-shadow: 0px 10px 20px 0px #e5e5e5;
}
#rating-1-10 button.btn.btn-primary {
  background-color: var(--mi-chat-primary-color) !important;
  color: #fff !important;
}
.primary-color {
  color: var(--mi-chat-primary-color) !important;
}

.top-header-ratingpb {
  background-color: #fff;
}
.bg-lightgray {
  background: #f1f1f1;
  height: 100vh;
}
.fineprint {
  color: #c0c0c0 !important;
}
.form-floating > label {
  width: 450px;
  height: 50px;
  text-align: left;
  opacity: 1 !important;
  background-color: #fff;
  z-index: 9;
  top: 5px;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  top: 7px;
  border-top: 1px solid #f2f2f2;
}
.login-bg-container-error {
  background: url('@/assets/img/login-bg.png');
  background-size: cover;
}
.login-bg-container-success {
  background: url('@/assets/img/login-bg-success.png');
  background-size: cover;
}
.login-bg-container-success.login-bg-container-error {
  background: url('@/assets/img/login-bg.png');
  background-size: cover;
}
.btn-primary {
  background-color: var(--mi-chat-primary-color) !important;
}
</style>
